import { TOfferCalculatorState } from '../types/redux';

export const selectDisplayAllFilters = (state: TOfferCalculatorState) => {
  return state.calculator.displayAllFilters;
};
